export default __webpack_public_path__ + "static/favicon-a5132378ea3d797ab6a0a6ca50d1bedf.ico";